import { makeStyles } from 'tss-react/mui';

import { XCloseIcon } from '@/components/icons/XCloseIcon';
import { WithClasses } from '@/styles/types';

import { Button, ButtonProps } from './Button';
import { IconButtonSize, iconSizesByButtonSize } from './IconButton';

export type CloseButtonProps = Omit<ButtonProps, 'size' | 'variant'> & {
  size: IconButtonSize;
  variant?: ButtonProps['variant'];
  classes?: WithClasses<typeof useStyles>;
};

const useStyles = makeStyles()((_theme) => ({
  closeButton: {
    margin: 0,
  },
}));

export function CloseButton(props: CloseButtonProps) {
  const { size, variant = 'transparent', ...restProps } = props;
  const { classes } = useStyles(undefined, { props });
  const iconSize = iconSizesByButtonSize[size];

  return (
    <Button
      size={size}
      variant={variant}
      className={classes.closeButton}
      square
      {...restProps}
    >
      {/* No icon color is set so the icon inherits `currentColor` from the
          Button's variant text color (via the SVG's `stroke="currentColor"`). */}
      <XCloseIcon size={iconSize} />
    </Button>
  );
}
